module.exports = __webpack_public_path__ + "img/oneGreen.43df9e0b.jpg";